/**
 * /tenants/{slug}/admins/delegated — Settings → Admins → Delegated: MSSP
 * tenant grants and organization grants in one list. The ?include_revoked
 * filter is URL state, validated here and handed to the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DelegatedPage } from "@/features/delegated-admins/pages/delegated-page";

const searchSchema = z.object({
  include_revoked: z.boolean().catch(false),
});

export const Route = createFileRoute("/_authed/tenants/$slug/admins/delegated")({
  validateSearch: searchSchema,
  component: DelegatedPage,
});
